
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 17","fill":"#55A3FF","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.246 11.587c-.039-.037-.204-.18-.34-.312-.855-.777-2.255-2.803-2.683-3.864-.068-.16-.214-.568-.223-.786 0-.208.048-.407.145-.596a1.25 1.25 0 01.603-.53c.175-.067.7-.171.71-.171.573-.104 1.506-.161 2.537-.161.982 0 1.876.057 2.459.142.01.01.661.114.885.227.408.209.661.616.661 1.052v.037c-.01.284-.263.881-.273.881-.428 1.003-1.759 2.983-2.644 3.779 0 0-.227.224-.369.321a1.189 1.189 0 01-.71.227 1.25 1.25 0 01-.758-.246","fill":"inherit"}})])
          )
        }
      }
    